export default __webpack_public_path__ + "static/media/Flag_of_Italy.bb2033dc.svg";